<p>test-auth2 works!</p>

<!--
<button (click)="login()">Login</button>

<button (click)="logout()">Logout</button>

 *ngIf="hasToken()"
<div >
  WE ARE LOGGED IN
</div>
 -->


<div *ngIf="isLoggedIn()">
  <div class="container">Hi and welcome!</div>
  <div class="container">Name: {{ userInfo?.info?.name }}</div>
  <div class="container"><img src="{{ userInfo?.info?.picture }}"></div>
  <div class="container">
    <button (click)="getEmails()">List Emails</button>
  </div>
  <div class="container"
       *ngFor="let snippet of mailSnippets">
    {{ snippet }}
  </div>
  <div class="container">
    <button (click)="logout()">Logout from Google</button>
  </div>
</div>
